export const brandsPage = {
  BrandsAZ: "All brands A-Z",
  JumpToLetter: "Jump to letter",
  SEODescription:
    "Stock in-office or prescribe virtually with over 300 professional grade supplement brands on Fullscript",
  SEOTitle: "Shop all Brands | Fullscript",
  ViewBrandsLetter: "View brands beginning with the letter {{letter}}",
} as const;
